import React from "react";
import { Nav, Button } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import {
  FaHome,
  FaTicketAlt,
  FaUser,
  FaFileInvoice,
  FaKey,
  FaSignOutAlt,
  FaChevronLeft,
  FaChevronRight,
  FaCreditCard,
  FaCrown, // Add this for My Plan
} from "react-icons/fa";

const Sidebar = ({ isCollapsed, toggleSidebar, onLogout }) => {
  const location = useLocation();

  const isActive = (path) => {
    if (path === "/") {
      return (
        location.pathname === "/dashboard" ||
        location.pathname === "/dashboard/"
      );
    }
    return location.pathname === `/dashboard${path}`;
  };

  return (
    <div
      className={`sidebar bg-dark text-white h-100 p-0 ${
        isCollapsed ? "collapsed" : ""
      }`}
    >
      <div className="p-3">
        <div className="d-flex justify-content-between align-items-center mb-4">
          {!isCollapsed && <h3 className="text-center mb-0">Dashboard</h3>}
          <Button
            variant="link"
            className="text-white p-0 toggle-btn"
            onClick={toggleSidebar}
          >
            {isCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
          </Button>
        </div>
        <Nav className="flex-column">
          <Nav.Link
            as={Link}
            to="/dashboard"
            className={`text-white mb-2 ${isActive("/") ? "active" : ""}`}
            title="Dashboard"
          >
            <FaHome className="me-2" /> {!isCollapsed && "Dashboard"}
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/dashboard/subscription"
            className={`text-white mb-2 ${
              isActive("/subscription") ? "active" : ""
            }`}
            title="Subscription"
          >
            <FaCreditCard className="me-2" /> {!isCollapsed && "Subscription"}
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/dashboard/my-plan"
            className={`text-white mb-2 ${
              isActive("/my-plan") ? "active" : ""
            }`}
            title="My Plan"
          >
            <FaCrown className="me-2" /> {!isCollapsed && "My Plan"}
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/dashboard/support-tickets"
            className={`text-white mb-2 ${
              isActive("/support-tickets") ? "active" : ""
            }`}
            title="Support Tickets"
          >
            <FaTicketAlt className="me-2" /> {!isCollapsed && "Support Tickets"}
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/dashboard/my-account"
            className={`text-white mb-2 ${
              isActive("/my-account") ? "active" : ""
            }`}
            title="My Account"
          >
            <FaUser className="me-2" /> {!isCollapsed && "My Account"}
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/dashboard/my-invoices"
            className={`text-white mb-2 ${
              isActive("/my-invoices") ? "active" : ""
            }`}
            title="My Invoices"
          >
            <FaFileInvoice className="me-2" /> {!isCollapsed && "My Invoices"}
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/dashboard/change-password"
            className={`text-white mb-2 ${
              isActive("/change-password") ? "active" : ""
            }`}
            title="Change Password"
          >
            <FaKey className="me-2" /> {!isCollapsed && "Change Password"}
          </Nav.Link>
          <Nav.Link
            className="text-white mb-2"
            onClick={onLogout}
            title="Logout"
          >
            <FaSignOutAlt className="me-2" /> {!isCollapsed && "Logout"}
          </Nav.Link>
        </Nav>
      </div>
    </div>
  );
};

export default Sidebar;
